<template>
  <div class="navMenu">
    <el-menu ref="menu" class="el-menu-vertical" :default-active="activeIndex" active-text-color="#fff"
      @open="handleOpen" @close="handleClose">
      <router-link :to="{ path: '/svolt/project',query:{projectId:projectId} }">
        <el-menu-item index="projectHome" style="padding-left:35px !important;">
          <i class="SideBar"></i>
          <span slot="title">首页</span>
        </el-menu-item>
      </router-link>
      <!-- 实时监控 -->
      <el-submenu index="1" v-if="activeModuleIds.indexOf(183)!=-1">
        <template slot="title">
          <i class="SideBar SideBar-01" data-flag="1"></i>
          <span slot="title" alias="实时监控">实时监控</span>
        </template>
        <router-link :to="{ path: '/svolt/dataSummary',query:{projectId:projectId, appid:'dataSummary'} }">
          <el-menu-item index="dataSummary" v-if="activeModuleIds.indexOf(1780165)!=-1">数据概览</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/diagram',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(190)!=-1">
          <el-menu-item index="wiringDiagram">一次接线</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/cellMonitoring',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(30256)!=-1">
          <el-menu-item index="cellMonitoring">电芯监控</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/clusterOverview',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(1600119)!=-1">
          <el-menu-item index="clusterOverview">簇总览</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/pileOverview',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810153)!=-1">
          <el-menu-item index="pileOverview">堆总览</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/pcsOverview',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810154)!=-1">
          <el-menu-item index="pcsOverview">PCS总览</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/centralizedPcsDetail',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810155)!=-1">
          <el-menu-item index="centralizedPcsDetail">PCS详情</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/airDetail',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810156)!=-1">
          <el-menu-item index="airDetail">实时空调</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/meter',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810157)!=-1">
          <el-menu-item index="Meter">实时电表</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/pileOverviewChart',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810158)!=-1">
          <el-menu-item index="pileOverviewChart">堆曲线查询</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/communicationStatus',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810159)!=-1">
          <el-menu-item index="communicationStatus">设备通讯状态</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/pcsCurveQuery',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810160)!=-1">
          <el-menu-item index="pcsCurveQuery">PCS曲线查询</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 历史数据 -->
      <el-submenu v-if="activeModuleIds.indexOf(30147)!=-1" index="2">
        <template slot="title">
          <i class="SideBar SideBar-02" data-flag="2"></i>
          <span alias="历史数据">历史数据</span>
        </template>
        <router-link :to="{ path: '/svolt/historyData',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(1600120)!=-1">
          <el-menu-item>全量数据</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 收益分析 -->
      <el-submenu v-if="activeModuleIds.indexOf(1660121)!=-1" index="3">
        <template slot="title">
          <i class="SideBar SideBar-03" data-flag="3"></i>
          <span alias="收益分析">收益分析</span>
        </template>
        <router-link :to="{ path: '/svolt/income',query:{projectId:projectId,appid:'incomeAssessment'} }">
          <el-menu-item index="incomeAssessment" v-if="activeModuleIds.indexOf(186)!=-1">收益评估</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/electrovalenceConfiguration',query:{projectId:projectId, appid:'electrovalenceConfiguration'} }">
          <el-menu-item index="electrovalenceConfiguration" v-if="activeModuleIds.indexOf(1720151)!=-1">电价配置</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 报表下载 -->
      <el-submenu index="4" v-if="activeModuleIds.indexOf(1660122)!=-1">
        <template slot="title">
          <i class="SideBar SideBar-04" data-flag="4"></i>
          <span alias="报表下载">报表下载</span>
        </template>
        <router-link :to="{ path: '/svolt/fullDownload',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(189)!=-1">
          <el-menu-item index="downloadData">簇下载</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/fullDownloadList',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1750153)!=-1">
          <el-menu-item index="fullDownloadList">全量下载</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/typicalDaily',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(1600122)!=-1">
          <el-menu-item>典型日报</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/downloadList',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(1600121)!=-1">
          <el-menu-item index="downloadList">下载列表</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 数据分析 -->
      <el-submenu index="5" v-if="activeModuleIds.indexOf(1630118)!=-1">
        <template slot="title">
          <i class="SideBar SideBar-05" data-flag="5"></i>
          <span alias="数据分析">数据分析</span>
        </template>
        <router-link :to="{ path: '/svolt/electricEnergyAnalysis',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(188)!=-1">
          <el-menu-item index="electricEnergyAnalysis">电能分析</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/electricQuantityAnalysis',query:{projectId:projectId} }"
                     v-if="activeModuleIds.indexOf(1750193)!=-1">
          <el-menu-item index="electricQuantityAnalysis">电量分析</el-menu-item>
        </router-link>
        <el-submenu class="submenuTitle" index="5-2" v-if="activeModuleIds.indexOf(1630114)!=-1">
          <template slot="title">簇内分析</template>
          <router-link :to="{ path: '/svolt/clusterElectricCoreMonth',query:{projectId:projectId} }"
            v-if="activeModuleIds.indexOf(1630115)!=-1">
            <el-menu-item v-if="activeModuleIds.indexOf(1630115)!=-1" index="clusterElectricCore1">月温压差</el-menu-item>
          </router-link>
          <router-link :to="{ path: '/svolt/clusterElectricCoreYear',query:{projectId:projectId} }"
            v-if="activeModuleIds.indexOf(1630116)!=-1">
            <el-menu-item v-if="activeModuleIds.indexOf(1630116)!=-1" index="clusterElectricCore2">年温压差</el-menu-item>
          </router-link>
        </el-submenu>
      </el-submenu>
      <!-- 历史事件 -->
      <el-submenu v-if="activeModuleIds.indexOf(1660123)!=-1" index="6">
        <template slot="title">
          <i class="SideBar SideBar-06" data-flag="6"></i>
          <span alias="历史事件">历史事件</span>
        </template>
        <router-link :to="{ path: '/svolt/newsCenter',query:{projectId:projectId} }"
          v-if="activeModuleIds.indexOf(1630117)!=-1">
          <el-menu-item>告警列表</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 储能核算 -->
      <el-submenu index="7" v-if="activeModuleIds.indexOf(1750143)!=-1">
      <!-- <el-submenu index="7"> -->
        <template slot="title">
          <i class="SideBar SideBar-06" data-flag="7"></i>
          <span alias="储能核算">储能核算</span>
        </template>
        <router-link :to="{ path: '/svolt/settlement',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1720126)!=-1">
          <el-menu-item>结算列表</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/replaceMeter',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1720133)!=-1">
          <el-menu-item>换表记录</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/userElectrovalence',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1690114)!=-1">
          <el-menu-item>用户电价</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/timezone',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1750148)!=-1">
          <el-menu-item>时区时段</el-menu-item>
        </router-link>
      </el-submenu>
      <!-- 控制及策略 -->
      <el-submenu index="8" v-if="activeModuleIds.indexOf(1690125)!=-1">
      <!-- <el-submenu index="7"> -->
        <template slot="title">
          <i class="SideBar SideBar-06" data-flag="8"></i>
          <span alias="控制及策略">控制及策略</span>
        </template>
        <router-link :to="{ path: '/svolt/policyManagement',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1690126)!=-1">
          <el-menu-item>策略管理</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/deviceControl',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1750174)!=-1">
          <el-menu-item>设备控制</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/controlOperationLog',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1750168)!=-1">
          <el-menu-item>操作日志</el-menu-item>
        </router-link>
        <router-link :to="{ path: '/svolt/energyManagement',query:{projectId:projectId} }" v-if="activeModuleIds.indexOf(1810167)!=-1">
          <el-menu-item>能量管理</el-menu-item>
        </router-link>
      </el-submenu>
      <router-link :to="{ path: '/svolt/ewm',query:{projectId:projectId} }">
        <el-menu-item index="ewm" style="padding-left:30px !important;">
          <i class="el-icon-mobile-phone"></i>
          <span slot="title">APP二维码下载</span>
        </el-menu-item>
      </router-link>
    </el-menu>
    <div style="position: absolute; text-align: justify; padding: 10px; top: calc(100% - 150px); line-height: 1.5; font-size: 10px; color: #405ea4">
      <span class="lock-desc">禁止分享账号密码给非业务相关人员使用，空闲账户24h联系网站管理员注销，因以上原因造成的数据安全事件，蜂巢能源不承担法律责任</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: '',
        /*
        接线图-190
        智能预警-184
        收益评估-186
        能耗分析-185
        历史数据-30147
        下载数据-189
        电能分析-188
        */
        projectMenuData: [{
            id: 'projectHome',
            resourceId: 0,
            srca: '/static/images/svolt/project-home-icon.png',
            srcb: '/static/images/svolt/project-home-icon-active.png',
            title: '首页'
          },
          {
            id: 'wiringDiagram',
            resourceId: 183,
            srca: '/static/images/svolt/wiring-diagram-icon.png',
            srcb: '/static/images/svolt/wiring-diagram-icon-active.png',
            title: '项目接线图'
          },
          {
            id: 'intelligentEarlyWarning',
            resourceId: 184,
            srca: '/static/images/svolt/intelligent-early-warning-icon.png',
            srcb: '/static/images/svolt/intelligent-early-warning-icon-active.png',
            title: '智能预警'
          },
          {
            id: 'incomeAssessment',
            resourceId: 186,
            srca: '/static/images/svolt/income-assessment-icon.png',
            srcb: '/static/images/svolt/income-assessment-icon-active.png',
            title: '收益评估'
          },
          {
            id: 'energyAnalysis',
            resourceId: 185,
            srca: '/static/images/svolt/energy-analysis-icon.png',
            srcb: '/static/images/svolt/energy-analysis-icon-active.png',
            title: '能耗分析'
          },
          // {id:'communicationDiagram',srca:'/static/images/svolt/communication-diagram-icon.png',srcb:'/static/images/svolt/communication-diagram-icon-active.png',title:'项目通讯图'},
          // {id:'controlStrategy',srca:'/static/images/svolt/control-strategy-icon.png',srcb:'/static/images/svolt/control-strategy-icon-active.png',title:'控制策略'},
          {
            id: 'historyData',
            resourceId: 30147,
            srca: '/static/images/svolt/history-data-icon.png',
            srcb: '/static/images/svolt/history-data-icon-active.png',
            title: '历史数据'
          },
          {
            id: 'downloadData',
            resourceId: 1600121,
            srca: '/static/images/svolt/download-data-icon.png',
            srcb: '/static/images/svolt/download-data-icon-active.png',
            title: '下载数据'
          },
          {
            id: 'electricEnergyAnalysis',
            resourceId: 188,
            srca: '/static/images/svolt/electric-energy-analysis-icon.png',
            srcb: '/static/images/svolt/electric-energy-analysis-icon-active.png',
            title: '电能分析'
          },
          {
            id: 'cellMonitoring',
            resourceId: 30256,
            srca: '/static/images/svolt/cell-data-icon.png',
            srcb: '/static/images/svolt/cell-data-icon-active.png',
            title: '电芯监控'
          },
          {
            id: 'meterMonitoring',
            resourceId: 30265,
            srca: '/static/images/svolt/meter-data-icon.png',
            srcb: '/static/images/svolt/meter-data-icon-active.png',
            title: '电表监控'
          },
          {
            id: 'newsCenter',
            resourceId: 30254,
            srca: '',
            srcb: '',
            title: '消息中心'
          }
        ],
        activeModuleIds: []
      };
    },
    created() {
      this.projectId = this.$route.query.projectId;
      this.activeIndex = this.$route.query.appid;
      let auth = localStorage.getItem('ActiveProjectModule');
      auth = JSON.parse(auth);
      this.activeModuleIds = auth.resourceIds;
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleSelect(index, indexPath) {
        for (let i in this.projectMenuData) {
          if (this.projectMenuData[i].id == index) {
            this.$emit('setMenu', this.projectMenuData[i].id, this.projectMenuData[i].resourceId);
          }
        }
        if (index == "projectHome") {
          this.$router.push({
            path: '/svolt/project',
            query: {
              projectId: this.projectId
            }
          })
        } else {
          this.$router.push({
            path: '/svolt/project',
            query: {
              projectId: this.projectId,
              appid: index
            }
          })
        }
      }
    }
  };
</script>

<style lang="scss">
  .navMenu {
    // .el-menu {
    //   background: transparent;
    // }

    // .el-submenu__title,
    // .el-submenu__title:hover {
    //   background-color: #6292F4 !important;
    // }

    // .el-menu-item-group__title,
    // .el-menu-item,
    // .el-submenu__title {
    //   color: #CBD9F8;
    // }

    // .el-submenu__title:hover {
    //   color: #fff;
    //   font-size: 14px;
    //   font-weight: 600;
    // }
    .el-menu-vertical {
      background: transparent;

      .submenuTitle {
        box-sizing: border-box;
        font-size: 14px;
        color: #fff;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;

        >.el-submenu__title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          padding-left: 80px !important;
        }

        .el-menu-item {
          padding-left: 100px !important;
        }
      }

      .el-menu-item {
        width: 240px;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        font-size: 14px;
        color: #fff;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        padding-left: 80px !important;

        &.is-active {
          position: relative;
          background-color: #2E59A7;
          width: 100%;

          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
            width: 2px;
            border-left: 2px solid #2E59A7;
          }
        }

        &:hover,
        &:focus {
          background-color: #2E59A7;
          color: #fff;
        }
      }

      .el-submenu {
        width: 100%;

        .el-menu {
          background-color: transparent;
        }
      }

      &.el-menu {
        border: 0 none;
        background-color: transparent;
        color: #fff;
        height: calc(100% - 200px);
        width: 100%;
        overflow-y: auto;
      }

      .el-submenu__title {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;

        &:hover {
          background-color: #2E59A7;
          color: #fff;
        }
      }

      .el-submenu__title,
      >.el-menu-item {
        height: 40px;
        line-height: 40px;
        padding: 0 35px !important;
        text-align: left;
        color: #fff;
      }

      .el-submenu__title i {
        color: #fff;
      }

      .el-submenu__icon-arrow {
        right: 40px;
      }

      .el-icon-arrow-down:before {
        font-size: 14px;
        font-weight: 600;
      }

      .SideBar {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 8px;

        &.SideBar-01 {
          background: url("/static/images/svolt/SideBar-01.png") no-repeat;
          background-size: 100% 100%;
        }

        &.SideBar-02 {
          background: url("/static/images/svolt/SideBar-02.png") no-repeat;
          background-size: 100% 100%;
        }

        &.SideBar-03 {
          background: url("/static/images/svolt/SideBar-03.png") no-repeat;
          background-size: 100% 100%;
        }

        &.SideBar-04 {
          background: url("/static/images/svolt/SideBar-04.png") no-repeat;
          background-size: 100% 100%;
        }

        &.SideBar-05 {
          background: url("/static/images/svolt/SideBar-05.png") no-repeat;
          background-size: 100% 100%;
        }

        &.SideBar-06 {
          background: url("/static/images/svolt/SideBar-06.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .el-icon-mobile-phone{
      color:rgba(255, 255, 255, 0.6);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/navMenu.vue